import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    successGetScreenList,
    failureGetScreenList,
} from "./ScreenList";
import { failureRolesScreenlist, RoleScreenlist, successRolesScreenlist } from "./RolesScreenList";

/**
 * API call to fetch all screens
 */
const getScreenListApi = () => {
    return api.get("/api/screen/");
};

/**
 * Saga to handle fetching screen list
 */
export function* getScreenListApiCall() {
    try {
        const response: AxiosResponse = yield call(getScreenListApi);
        yield put(successGetScreenList(response.data));
    } catch (error) {
        yield put(failureGetScreenList(error));
    }
}


const getRolesScreenlistApi = (action: PayloadAction<RoleScreenlist>) => {
    return api.get("/api/screen/roles/screens",{ params: action.payload });
};

/**
 * Saga to handle fetching screen list
 */
export function* getRolesScreenlistApiCall(action: PayloadAction<RoleScreenlist>) {
    try {
        const response: AxiosResponse = yield call(getRolesScreenlistApi, action);
        yield put(successRolesScreenlist(response.data));
    } catch (error) {
        yield put(failureRolesScreenlist(error));
    }
}